import React from "react";
import { withSiteData } from "react-static";
//
import Navigation from "components/navigation";
//
export default withSiteData(({ navigation }) => (
  <Navigation navigation={navigation} />
));
